import classNames from 'classnames'

import { TypeCloudinaryImageJSON } from 'hello_baby/types/guides'
import { cloudinaryImageURL } from 'hello_baby/lib/cloudinary'
import { Image } from 'baby-design'

import css from './styles.scss'

interface TypePostEmbedImageFields {
  format: 'Normal' | 'Left' | 'Right'
  image: TypeCloudinaryImageJSON | TypeCloudinaryImageJSON[]
  altText: string
  imageTitle: string
}

interface EmbedImageProps {
  fields: TypePostEmbedImageFields
}

const EmbedImage: React.FC<EmbedImageProps> = ({ fields }: EmbedImageProps) => {
  const url = cloudinaryImageURL(fields.image)
  if (!url) return null

  return (
    <Image
      alt={fields.altText || 'Babylist Guides Image'}
      className={classNames('img-responsive', {
        [css['EmbedImage__wrap-right-image']]: fields.format === 'Right',
        [css['EmbedImage__wrap-left-image']]: fields.format === 'Left',
      })}
      src={url}
    />
  )
}

export default EmbedImage
